import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCheckUserExistsMutation } from '../../api-integration/secure/api.kiosk';
import { normalizeAPIResponse } from '../../util/normalizeAPIResponse';
import { LoadingSpinner } from '../../components/common/loading-spinner';

type HandleRoutingParams = {
    isValidToken: boolean;
    isConsentProvided: boolean;
    isPhoneVerified: boolean;
    isLoggedIn: boolean
};


const KioskHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const kioskInviteToken = new URLSearchParams(location.search).get("kioskInviteToken");
    const isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || 'false');

    const [checkUserExistsAPI, checkUserExistsResult] = useCheckUserExistsMutation();

    const handleRouting = ({isValidToken,isConsentProvided,isPhoneVerified, isLoggedIn}: HandleRoutingParams) => {
        if (!isValidToken) {
            navigate('/invalid-invite', { replace: true });
            return;
        }
        if (!isConsentProvided) {
            navigate('/consent', { replace: true });
            return;
        }
        if (!isLoggedIn) {
            navigate('/login', { replace: true });
            return;
        }
        if (!isPhoneVerified) {
            navigate('/verify', { replace: true });
            return;
        }
        navigate('/home', { replace: true });
    };

    useEffect(() => {
        if (!kioskInviteToken) {
            navigate('/invalid-invite', { replace: true });
            return;
        }
        localStorage.setItem("kioskInviteCode", kioskInviteToken);
        checkUserExistsAPI({ kioskInviteToken: kioskInviteToken });
    }, [kioskInviteToken]);

    useEffect(() => {
        if(checkUserExistsResult?.isSuccess || checkUserExistsResult?.isError) {
            const response = normalizeAPIResponse(checkUserExistsResult);
            if(response?.success === true) {
                const userDetails = response?.data?.userDetails || {};
                localStorage.setItem('isPhoneVerified', JSON.stringify(userDetails?.isPhoneVerified));
                localStorage.setItem('isConsentProvided', JSON.stringify(userDetails?.isConsentProvided));
                handleRouting({
                    isValidToken: true,
                    isConsentProvided: userDetails?.isConsentProvided ?? false,
                    isPhoneVerified: userDetails?.isPhoneVerified ?? false,
                    isLoggedIn: isLoggedIn
                });
            }
            else {
                handleRouting({
                    isValidToken: false,
                    isConsentProvided: false,
                    isPhoneVerified: false,
                    isLoggedIn: isLoggedIn
                });
            }
        }
    },[checkUserExistsResult?.isSuccess, checkUserExistsResult?.isError]);

    // While processing, show a loading indicator
    return (
        <div>
            <LoadingSpinner />
        </div>
    )
};

export default KioskHandler;